import React, { useContext } from "react";
import styles from './topBar.module.css'
import {AiOutlineSearch,AiOutlineBell,AiOutlineSetting,AiOutlineHome,AiOutlinePoweroff} from 'react-icons/ai'
import {MdExplore} from 'react-icons/md'
import { ThemeContext } from "../../../context/themeContext";
import { UserContext } from "../../../context/userContext";
import {VscColorMode} from 'react-icons/vsc'
import { UserDataContext } from "../../../context/userData";
import {AiOutlinePlus} from 'react-icons/ai'
import { NavIconContext } from "../../../context/NavIconContext";
import { Link } from "react-router-dom";
import ReactLoading from 'react-loading';

const TopBar=()=>{
    const {userData}=useContext(UserDataContext)
    const {theme,handleThemeChange}=useContext(ThemeContext); 
    const {logout,logoutLoading}=useContext(UserContext);
    const{setAddpost,addpost,setIconState,setNotificationShow}=useContext(NavIconContext);

    const rotate ={transform:"rotate(45deg)",color:"#7124BD"}

const tranformRotate = {transform:"rotate(45deg)"}


    return(<div className={styles.topBarContainer}>
        <div className={styles.addCon}>
            <abbr title="add Post" style={{cursor:"pointer"}}>

                
                <AiOutlinePlus style={addpost?tranformRotate:{}} onClick={()=>setAddpost(!addpost)}/>
                          </abbr>
        </div>
        <div className={styles.scon}>
            <AiOutlineSearch style={{fontSize:"23px"}}/>
            <input placeholder="Search"/>
        </div>
        <div className={styles.notiarea}>
            <abbr style={{cursor:"pointer"}} title="Goto Home">
                <Link to="/">
        <AiOutlineHome onClick={()=>setIconState("newfeed")} className={styles.icons}/>
        </Link>
        </abbr>
        <abbr style={{cursor:"pointer"}} title="Notifications">
            <AiOutlineBell onClick={()=>setNotificationShow(true)} className={styles.icons}/>
            </abbr>
            <abbr style={{cursor:"pointer"}} title="explore">
                <Link to="/explore">
            <MdExplore className={styles.icons}/>
            </Link>
            </abbr>
            <Link to="/setting">
            <abbr style={{cursor:"pointer"}} title="Setting">
            <AiOutlineSetting className={styles.icons} />
            </abbr></Link>
        
            <abbr style={{cursor:"pointer"}} title="Theme">
            <VscColorMode onClick={handleThemeChange} style={{color:theme==="light"?"black":"white"}} className={styles.icons}  />
            </abbr>
            <abbr style={{cursor:"pointer"}} title="Logout">
             {logoutLoading?  
              <div style={{marginLeft:"10px"}}> 
             <ReactLoading type={"spin"} color={"#7124BD"}   height={25} width={20} />
             </div>
             : 
            
            <AiOutlinePoweroff  onClick={logout} className={styles.icons}/> }
           
            </abbr>

        </div>
        <div className={styles.user}>
            <img className={styles.userimg} alt="profile"  src={`${userData.Profile_Image}`}/>

        </div>
    </div>)
}

export default TopBar